import ImageViewer from "./Image"
import VideoViewer from "./Video"

const LazyLoad = {
    Image: ImageViewer,
    Video: VideoViewer
}

export default LazyLoad